{
  "collections": [
    {
      "id": "a26adcd8-4045-11ed-8200-acde48001122",
      "title": "Colours",
      "items": [
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/01-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/01.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/02-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/02.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/03-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/03.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/04-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/04.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/05-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/05.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/06-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/06.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/07-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/07.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/08-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/08.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/09-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/09.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/10-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/10.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/11-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/11.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/12-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/12.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/13-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/13.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/14-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/14.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/15-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/15.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/16-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/16.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/17-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/17.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/18-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/18.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/19-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/19.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/20-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/20.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/21-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/21.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/22-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/22.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/23-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/23.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 370,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/24-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/24.png",
          "type": "image",
          "width": 1080,
          "height": 1080
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/25-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/25.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/26-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/26.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/27-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/27.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/28-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/28.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "image": {
              "width": 370,
              "height": 194,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/29-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/colours/29.mp4",
          "type": "video",
          "width": 1280,
          "height": 674
        }
      ]
    },
    {
      "id": "a27a1108-4045-11ed-8200-acde48001122",
      "title": "Retro",
      "items": [
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 164,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-background-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 164,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-background-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-background.mp4",
          "type": "video",
          "width": 4320,
          "height": 1918
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 164,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-background-with-dancers-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 164,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-background-with-dancers-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-background-with-dancers.mp4",
          "type": "video",
          "width": 4320,
          "height": 1918
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 164,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-street-background-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 164,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-street-background-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/beatfighter-street-background.mp4",
          "type": "video",
          "width": 4318,
          "height": 1918
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/boop-bop-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/boop-bop-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/boop-bop.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-glitch-b_w-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-glitch-b_w-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-glitch-b_w.mp4",
          "type": "video",
          "width": 976,
          "height": 550
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-martians-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-martians-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-martians-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-martians-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-martians-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-martians-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-metropolis-mayhem-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-metropolis-mayhem-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-metropolis-mayhem-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-metropolis-mayhem-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-metropolis-mayhem-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-metropolis-mayhem-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-1-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-1-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-1-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-1-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-1-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-1-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-2-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-2-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-2-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-2-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-2-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-old-timey-2-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-rainbow-glitch-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-rainbow-glitch-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-rainbow-glitch.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-robot-radness-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-robot-radness-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-robot-radness-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-robot-radness-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-robot-radness-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-robot-radness-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-sketchy-future-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-sketchy-future-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-sketchy-future-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-sketchy-future-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-sketchy-future-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-sketchy-future-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-space-kidz-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-space-kidz-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-space-kidz-1.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-space-kidz-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-space-kidz-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/cartoon-space-kidz-2.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/everybody-bopping-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/everybody-bopping-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/everybody-bopping.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-driving-loop-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-driving-loop-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-driving-loop.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-loopy-loop-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-loopy-loop-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-loopy-loop.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-space-zoom-fast-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-space-zoom-fast-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-space-zoom-fast.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-2-tone-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-2-tone-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-2-tone-1.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-2-tone-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-2-tone-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-2-tone-2.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-360-colour-1-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-360-colour-1-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-360-colour-1.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-360-colour-2-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-360-colour-2-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-take-a-drive-360-colour-2.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-vintage-look-around-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-vintage-look-around-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/la-vintage-look-around.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/live-set-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/live-set-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/live-set.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-ghost-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-ghost-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-ghost.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-reflections-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-reflections-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-reflections.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-the-tube-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-the-tube-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-the-tube.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-time-elapsed-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-time-elapsed-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-time-elapsed.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-ye-olde-town-road-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-ye-olde-town-road-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/lndn-ye-olde-town-road.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-city-bw-long-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-city-bw-long-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-city-bw-long.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-echo-bw-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-echo-bw-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-echo-bw.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-layers-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-layers-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-layers.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-liberty-long-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-liberty-long-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-liberty-long.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-subway-long-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-subway-long-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-subway-long.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-tryptic-long-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-tryptic-long-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/ny-tryptic-long.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/prancing-cats-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/prancing-cats-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/prancing-cats.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/rococo-mansion-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/rococo-mansion-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/rococo-mansion.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/the-waiters-waltz-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/the-waiters-waltz-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/the-waiters-waltz.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/weird-walrus-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/weird-walrus-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/weird-walrus.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/wild-walrus-quartet-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/wild-walrus-quartet-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/retro/wild-walrus-quartet.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        }
      ]
    },
    {
      "id": "a3237536-4045-11ed-8200-acde48001122",
      "title": "Trippy",
      "items": [
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/b_w-kaledia-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/b_w-kaledia-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/b_w-kaledia.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/butterflies-natural-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/butterflies-natural-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/butterflies-natural.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/butterflies-psychedelic-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/butterflies-psychedelic-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/butterflies-psychedelic.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/cat-rave-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/cat-rave-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/cat-rave.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/colourful-jelly-fish-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/colourful-jelly-fish-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/colourful-jelly-fish.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/crashing-waves-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/crashing-waves-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/crashing-waves.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/crazy-nature-combo-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/crazy-nature-combo-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/crazy-nature-combo.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/double-exposure-jelly-fish-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/double-exposure-jelly-fish-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/double-exposure-jelly-fish.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/enchanted-forest-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/enchanted-forest-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/enchanted-forest.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fast-forest-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fast-forest-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fast-forest.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fast-trippy-forest-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fast-trippy-forest-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fast-trippy-forest.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fists-background-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fists-background-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fists-background.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/flower-and-clouds-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/flower-and-clouds-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/flower-and-clouds.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/flower-clouds-b-w-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/flower-clouds-b-w-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/flower-clouds-b-w.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fruit-salad-nogifs-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fruit-salad-nogifs-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fruit-salad-nogifs.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fruit-salad-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fruit-salad-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/fruit-salad.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/glitch-b-w-kaledia-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/glitch-b-w-kaledia-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/glitch-b-w-kaledia.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/glitch-round-2-b-w-kaledia-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/glitch-round-2-b-w-kaledia-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/glitch-round-2-b-w-kaledia.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/legs-background-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/legs-background-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/legs-background.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/liquid-grid-b-w-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/liquid-grid-b-w-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/liquid-grid-b-w.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/live-set-screens-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/live-set-screens-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/live-set-screens.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-bigger-ben-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-bigger-ben-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-bigger-ben.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-kings-cigars-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-kings-cigars-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-kings-cigars.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-tube-mirror-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-tube-mirror-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-tube-mirror.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-tube-trip-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 214,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-tube-trip-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/lndn-tube-trip.mp4",
          "type": "video",
          "width": 1240,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/mouth-background-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/mouth-background-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/mouth-background.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/nuclear-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/nuclear-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/nuclear.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/ny-cartoon-chaos-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/ny-cartoon-chaos-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/ny-cartoon-chaos.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/psychedelic-trees-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/psychedelic-trees-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/psychedelic-trees.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/shaking-trees-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/shaking-trees-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/shaking-trees.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/spread-love-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/spread-love-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/spread-love.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/stoners-oddysey-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/stoners-oddysey-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/stoners-oddysey.mp4",
          "type": "video",
          "width": 1920,
          "height": 1080
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/tree-zooming-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/tree-zooming-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/tree-zooming.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        },
        {
          "preview": {
            "video": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/wobbling-water-thumbnail.mp4"
            },
            "image": {
              "width": 370,
              "height": 208,
              "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/wobbling-water-thumbnail.png"
            }
          },
          "src": "https://static.serato.com/visualizer/gallery/v2/backgrounds/trippy/wobbling-water.mp4",
          "type": "video",
          "width": 1280,
          "height": 720
        }
      ]
    }
  ]
}